import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const StyledFlexItem = styled.div`
  ${({ order }) => order !== undefined && 'order:' + order + ';'}
  ${({ flexGrow }) => flexGrow !== undefined && 'flex-grow:' + flexGrow + ';'}
  ${({ flexShrink }) =>
    flexShrink !== undefined && 'flex-shrink:' + flexShrink + ';'}
  ${({ flexBasis }) => flexBasis && 'flex-basis:' + flexBasis + ';'}
  ${({ flex }) => flex && 'flex:' + flex + ';'}
  ${({ alignSelf }) => alignSelf && 'align-self:' + alignSelf + ';'}
  ${({ justifySelf }) => justifySelf && 'justify-self:' + justifySelf + ';'}
  
  ${({ margin }) => margin && 'margin:' + margin + ';'}
  ${({ padding }) => padding && 'padding:' + padding + ';'}
  ${({ width }) => width && 'width:' + width + ';'}
  ${({ height }) => height && 'height:' + height + ';'}
  ${({ maxWidth }) => maxWidth && 'max-width:' + maxWidth + ';'}
  ${({ maxHeight }) => maxHeight && 'max-height:' + maxHeight + ';'}
  ${({ minWidth }) => minWidth && 'min-width:' + minWidth + ';'}
  ${({ minHeight }) => minHeight && 'min-height:' + minHeight + ';'}
`

export const FlexItem = ({ children, ...props }) => {
  return <StyledFlexItem {...props}>{children}</StyledFlexItem>
}

FlexItem.propTypes = {
  children: PropTypes.node,
  order: PropTypes.number,
  flexGrow: PropTypes.number,
  flexShrink: PropTypes.number,
  flexBasis: PropTypes.string,
  flex: PropTypes.string,
  alignSelf: PropTypes.oneOf([
    'auto',
    'flex-start',
    'flex-end',
    'center',
    'baseline',
    'stretch'
  ]),
  justifySelf: PropTypes.oneOf([
    'auto',
    'flex-start',
    'flex-end',
    'center',
    'baseline',
    'stretch'
  ]),
  margin: PropTypes.string,
  padding: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  maxWidth: PropTypes.string,
  maxHeight: PropTypes.string,
  minWidth: PropTypes.string,
  minHeight: PropTypes.string
}
